<script setup>
import { useI18n } from 'vue-i18n'

/** The points a player earned, as a chip: its style lives here, so it stays the same everywhere. */
defineProps({
  /** Points earned in an event, or on one track of it. */
  points: { type: Number, required: true },
})

const { t } = useI18n()
</script>

<template>
  <v-chip size="small" variant="tonal" label>
    {{ points }} {{ t('events.points') }}
  </v-chip>
</template>
